module.exports = __webpack_public_path__ + "img/small.9564d955.jpg";